(function () {

  console.log('[Custom Judge.me] JS loaded');

  const WIDGET_SELECTOR = '#judgeme_product_reviews';
  const REVIEW_SELECTOR = '.jdgm-rev';
  const AUTHOR_WRAPPER_SELECTOR = '.jdgm-rev__author-wrapper';
  const AUTHOR_SELECTOR = '.jdgm-rev__author';
  const BADGE_SELECTOR = '.jdgm-rev__buyer-badge-wrapper';

  let observer = null;
  let updateTimer = null;

  /**
   * On garde une copie permanente
   * d'un vrai badge Judge.me.
   */
  let savedBadgeTemplate = null;


  function getWidget() {

    return document.querySelector(
      WIDGET_SELECTOR
    );

  }


  /**
   * Chercher et mémoriser
   * un vrai badge Judge.me.
   */
  function saveBadgeTemplate(widget) {

    if (savedBadgeTemplate) {
      return true;
    }

    if (!widget) {
      return false;
    }

    const nativeBadge = widget.querySelector(
      BADGE_SELECTOR
    );

    if (!nativeBadge) {
      return false;
    }

    savedBadgeTemplate =
      nativeBadge.cloneNode(true);

    console.log(
      '[Custom Judge.me] badge template saved'
    );

    return true;

  }


  /**
   * Supprimer les éventuels doublons.
   *
   * On garde le premier badge
   * et on supprime les suivants.
   */
  function removeDuplicateBadges(review) {

    const authorWrapper =
      review.querySelector(
        AUTHOR_WRAPPER_SELECTOR
      );

    if (!authorWrapper) {
      return;
    }

    const badges =
      authorWrapper.querySelectorAll(
        BADGE_SELECTOR
      );

    if (badges.length <= 1) {
      return;
    }

    badges.forEach(function (
      badge,
      index
    ) {

      if (index > 0) {

        badge.remove();

      }

    });

  }


  /**
   * Ajouter les badges manquants.
   */
  function addVerifiedBadges() {

    const widget = getWidget();

    if (!widget) {

      console.log(
        '[Custom Judge.me] widget not found'
      );

      return;

    }


    /**
     * Sauvegarder un badge natif
     * dès qu'il est disponible.
     */
    saveBadgeTemplate(widget);


    const reviews =
      widget.querySelectorAll(
        REVIEW_SELECTOR
      );


    console.log(
      '[Custom Judge.me] reviews found:',
      reviews.length
    );


    if (!reviews.length) {
      return;
    }


    /**
     * Nettoyer d'abord
     * les éventuels doublons.
     */
    reviews.forEach(function (review) {

      removeDuplicateBadges(review);

    });


    /**
     * Si aucun vrai badge Judge.me
     * n'a encore été trouvé.
     */
    if (!savedBadgeTemplate) {

      console.log(
        '[Custom Judge.me] waiting for native badge template'
      );

      return;

    }


    reviews.forEach(function (review) {

      const authorWrapper =
        review.querySelector(
          AUTHOR_WRAPPER_SELECTOR
        );

      if (!authorWrapper) {
        return;
      }


      /**
       * Si un badge existe déjà,
       * ne rien ajouter.
       */
      const existingBadge =
        authorWrapper.querySelector(
          BADGE_SELECTOR
        );

      if (existingBadge) {
        return;
      }


      const author =
        authorWrapper.querySelector(
          AUTHOR_SELECTOR
        );

      if (!author) {
        return;
      }


      /**
       * Cloner notre modèle
       * Judge.me sauvegardé.
       */
      const newBadge =
        savedBadgeTemplate.cloneNode(true);


      /**
       * Identifier uniquement
       * les badges ajoutés par nous.
       */
      newBadge.dataset.customVerifiedBadge =
        'true';


      /**
       * Petit espace entre
       * le nom et notre badge.
       *
       * Cela ne modifie pas
       * les badges natifs Judge.me.
       */
      newBadge.style.marginLeft = '5px';


      /**
       * Ajouter après le nom.
       */
      author.insertAdjacentElement(
        'afterend',
        newBadge
      );


      console.log(
        '[Custom Judge.me] badge added:',
        author.textContent.trim()
      );

    });


    /**
     * Nettoyage final
     * pour éviter tout doublon.
     */
    reviews.forEach(function (review) {

      removeDuplicateBadges(review);

    });

  }


  /**
   * Scheduler.
   */
  function scheduleUpdate(delay) {

    if (typeof delay !== 'number') {
      delay = 100;
    }

    clearTimeout(updateTimer);

    updateTimer = setTimeout(
      function () {

        addVerifiedBadges();

      },
      delay
    );

  }


  /**
   * Après pagination ou tri,
   * Judge.me peut faire plusieurs
   * rendus successifs.
   */
  function watchAfterAjaxChange() {

    const delays = [
      50,
      150,
      300,
      500,
      800,
      1200,
      1800,
      2500,
      3500
    ];


    delays.forEach(function (delay) {

      setTimeout(function () {

        addVerifiedBadges();

      }, delay);

    });

  }


  /**
   * Observer les modifications DOM.
   */
  function startObserver() {

    if (observer) {

      observer.disconnect();

    }


    observer =
      new MutationObserver(
        function (mutations) {

          let relevant = false;


          for (const mutation of mutations) {

            if (
              mutation.type === 'childList' &&
              (
                mutation.addedNodes.length ||
                mutation.removedNodes.length
              )
            ) {

              relevant = true;

              break;

            }

          }


          if (!relevant) {
            return;
          }


          scheduleUpdate(100);

        }
      );


    observer.observe(
      document.documentElement,
      {
        childList: true,
        subtree: true
      }
    );


    console.log(
      '[Custom Judge.me] observer started'
    );

  }


  /**
   * Initialisation.
   */
  function init() {

    startObserver();

    watchAfterAjaxChange();

  }


  /**
   * Chargement initial.
   */
  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      init,
      {
        once: true
      }
    );

  } else {

    init();

  }


  /**
   * Pagination Judge.me.
   */
  document.addEventListener(
    'click',
    function (event) {

      const button =
        event.target.closest(
          '.jdgm-paginate__page'
        );


      if (!button) {
        return;
      }


      console.log(
        '[Custom Judge.me] pagination clicked:',
        button.dataset.page
      );


      /**
       * Judge.me va reconstruire
       * la liste des reviews.
       */
      watchAfterAjaxChange();

    },
    true
  );


  /**
   * Changement de tri Judge.me.
   */
  document.addEventListener(
    'change',
    function (event) {

      if (
        !event.target.matches(
          '.jdgm-sort-dropdown'
        )
      ) {

        return;

      }


      console.log(
        '[Custom Judge.me] sort changed'
      );


      watchAfterAjaxChange();

    },
    true
  );


  /**
   * Shopify Theme Editor.
   */
  document.addEventListener(
    'shopify:section:load',
    function () {

      console.log(
        '[Custom Judge.me] Shopify section loaded'
      );


      watchAfterAjaxChange();

    }
  );


})();